import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
import Progress from './Progress';
import { apiPath } from "../src/services/apiConfig";

function Testimonials() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayTestimonial, setDisplayTestimonial] = useState('none');
  const [displayUpdDepartment, setDisplayUpdDepartment] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  // const [uid, setUID] = useState('');
  // const [specialityType, setSpecialityType] = useState('1');
  const [verfied, setVerfied] = useState(true);
  const [id, setID] = useState('');
  // const [uidErr, setUIDErr] = useState('');
  // const [Err, SetErr] = useState([]);
  const formRef = useRef();
  const [doctorSpecilation, setDoctorSpecialisation] = useState();
  const [patientName, setPatientName] = useState('');
  const [specialityDataStat, setSpecialityDataStat] = useState('')
  const [testimonialsTxt, setTestimonialsTxt] = useState('');
  const [specialityData, setSpecialityData] = useState([])
  const [isloading, setIsLoading] = useState(false)
  const [IsDisabled, setIsDisabled] = useState(false)
  const [spid, setUpdSpid] = useState();
  //  const [updName, setUpdName] = useState();
  const [updTxt, setUpdTxt] = useState();
  const [updPatient, setUpdPatient] = useState();
  const [filteredID, setFilteredId] = useState()
  const [defaultSpeciality, setDefaultSpeciality] = useState('1')

  let txt = "";

  useEffect(() => {
    //    getDepartment()
    getTestimonials(defaultSpeciality)
    getSpeciality()
  }, [])

  const handleSubmit = () => {
    verifyTestimonial()

    if (verfied) {
      formRef.current.reset();
    }
  }

  function openTestimonial() {
    setDisplayTestimonial('block')
  }

  function closeTestmonial() {
    formRef.current.reset();
    setDisplayTestimonial('none')
  }

  function openUpdDepartment() {
    setDisplayUpdDepartment('block')
  }

  function closeUpdUser() {
    setDisplayUpdDepartment('none')
  }

  async function updateTestimonial(id, spid) {

    setIsLoading(true)

    let result = await fetch(apiPath + "updateTestimonial/" + id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "txt": updTxt,
        "patient_name": updPatient
      })
    });

    result = await result.json()

    showSwal(result.success, result.message)
    getTestimonials(spid)

    if (isloading) {
    } else {
      setIsLoading(false)
    }
  }

  async function deleteDepartment(id) {

    let result = await fetch(apiPath + "deleteTestimonial/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)
    getTestimonials(filteredID)
  }



  async function updateOperation(id) {

    let result = await fetch(apiPath + "getTestimonial/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },

      });

    result = await result.json();

    console.warn(result.data)

    setUpdSpid(result.data[0].speciality_id)
    //    setUpdName(result.data[0].speciality_name);
    setUpdTxt(result.data[0].txt);
    setUpdPatient(result.data[0].patient_name)
    setID(result.data[0].id)

    openUpdDepartment();
  }


  function deleteOperation(id) {
    //alert(id)
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteDepartment(id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }
  //* LIST OF ALL TESTIMONIALS (for initial screen)*/ 

  async function getTestimonials(id) {
    let result = await fetch(apiPath + "TestimonialsBySpeciality/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
//      setUID(item)
    }
  }
    */}

  function verifyTestimonial() {
    setVerfied(true)
    addTestimonials()
  }

  {/*ADD A NEW DEPARTMENT*/ }

  async function addTestimonials() {

    setIsLoading(true)
    if (verfied) {

      //alert('Add: '+testimonialsTxt)
      setIsDisabled(true)
      setIsLoading(true)

      let result = await fetch(apiPath + "storeTestimonial", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "speciality_id": filteredID,
          "txt": testimonialsTxt,
          "patient_name": patientName
        })

      });
      result = await result.json();
      //  console.warn(result)

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      setIsDisabled(false)

      showSwal(result.success, result.message)
      getTestimonials(filteredID)

      if (isloading) {
      } else {
        setIsLoading(false)
      }
    }
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  //* LIST OF ALL SPECIALITY (for combo)*/ 

  async function getSpeciality() {
    let result2 = await fetch(apiPath + "specialities",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result2 = await result2.json();
    setSpecialityDataStat(result2.success);
    //  setSpecialityData(result2.data);
    if (result2.success === true) {
      setSpecialityData(result2.data);
    } else { setSpecialityData([]) }
  }


  function FilterData(id) {
    getTestimonials(id)
    setFilteredId(id)
  }

  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Speciality Testimonials</h4>
            </div>
            <div className="c12-l-5"></div>
            <div className="c12-l-2">
              <select className="custom-select" onChange={(e) => FilterData(e.target.value)}>
                {
                  (specialityDataStat === true ?
                    (
                      specialityData.map((item2, index) =>
                        <option value={item2.id} >{item2.name}</option>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </select>
            </div>
            <div className="c12-l-2">
              <button onClick={openTestimonial} type="button" name="button"
                className="btn solid round">Create Testimonials</button>
            </div>
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="15%">Id</th>
                  <th className="th-border left" width="22%">Speciality</th>
                  <th className="th-border left" width="22%">patient Name</th>
                  <th className="th-border left" width="55%">patient Testimonials</th>
                  <th className="th-border left" width="20%">Edit</th>
                  <th className="th-border left" width="20%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="left">{item.speciality_name}</td>
                          <td className="left">{item.patient_name}</td>
                          <td className="left">{item.txt}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.id, { filteredID }) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW TESTIMONIAL */}

          <div id="newdept" style={{ 'display': displayTestimonial }} className="cont__new-dept">
            <form className="" action="" method="" ref={formRef}>
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeTestmonial}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add Testimonial</h2>
                  <br></br>

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Patient Name" onChange={(e) => setPatientName(e.target.value)} />


                  <input type="hidden" value={doctorSpecilation} />
                  {/*
                            <select className="custom-select" onChange={(e)=>setDoctorSpecialisation(e.target.value)}>
                              <option value = '0' >Select Speciality</option>
                              {
                                (specialityDataStat === true ?
                                (
                                  specialityData.map((item2,index)=>
                                    <option value={item2.id} >{item2.name}</option>    
                                ))
                                : <tr><td>No data</td></tr>)
                              }
                            </select>
*/}
                  <textarea className="box small" autoComplete="off" rows='10'
                    placeholder="Testimonials" onChange={(e) => setTestimonialsTxt(e.target.value)} />

                  <br></br>
                  <button disabled={IsDisabled} type="button" onClick={handleSubmit}
                    className="btn solid round">Add Testimonials</button>

                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdDepartment }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdUser}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Testimonial</h2><br /><br />

                  <input type="hidden" value={id} />
                  <input type="hidden" value={spid} />

                  <input type="text" className="box small"
                    placeholder="Text" onChange={(e) => setUpdPatient(e.target.value)}
                    value={updPatient} />

                  <textarea className="box small" rows='10'
                    placeholder="Text" onChange={(e) => setUpdTxt(e.target.value)}
                    value={updTxt} />

                  <br></br>
                  <button onClick={() => { updateTestimonial(id, spid) }} type="button"
                    className="btn solid round">Update Testimonial</button>

                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
